import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from "react-modal";
import { useAuthContext } from '../hooks/useAuthContext';
//import components and modals
import AddNewInv from '../components/modals/inv modals/AddNewInv';
import EditInv from '../components/modals/inv modals/EditInv';
import DetailsModal from '../components/modals/inv modals/DetailsModal';
import CreateSaleOrderForm from '../components/modals/request modals/CreateSaleOrder';

const InventoryPage = () => {
    const [watches, setWatches] = useState(null); //watches variable will hold all inventory watches returned from API call to DB
    const [selectedWatch, setSelectedWatch] = useState();
    const [openAddWatchModal, setOpenAddWatchModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [openCreateSOForm, setOpenCreateSOForm] = useState(false);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook

    //get screensize
    const getScreenSize = () => {
        const width = window.innerWidth;
        if (width < 500) return 'xsmall';
        if (width >= 500 && width < 800) return 'small';
        if (width >= 800 && width < 1440) return 'medium';
        return 'large';
    };
    const [screenSize, setScreenSize] = useState(getScreenSize());

    useEffect(() => {
        const getInventory = async () => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_SERVER_URL + '/api/inventory',
                    {headers: {'Authorization': `Bearer ${user.token}`}}
                ); //get all watches in inventory
                setWatches(response.data);
            } catch (error) {
                console.error('Failed to get watches in inventory: ' + error.message);
            }
        }

        if (user) {
            getInventory();
        }

        const handleResize = () => {
            setScreenSize(getScreenSize());
          };
      
        window.addEventListener('resize', handleResize);
      
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [user])


    
    const addWatch = () => {
        setOpenAddWatchModal(true);
    }
    const closeAddWatchModal = () => {
        setOpenAddWatchModal(false);
    }

    const edit = (watch) => {
        setOpenEditModal(true);
        setSelectedWatch(watch);
    }
    const closeEdit = () => {
        setOpenEditModal(false);
    }

    const details = (watch) => {
        setOpenDetailsModal(true);
        setSelectedWatch(watch);
    }
    const closeDetails = () => {
        setOpenDetailsModal(false);
    }

    const createSaleOrder = (watch) => {
        setSelectedWatch(watch);
        setOpenCreateSOForm(true);
    }
    const closeCreateSaleOrder = () => {
        setOpenCreateSOForm(false);
    }

    const deleteInv = async (id) => {
        try {
            const response = await axios.delete(process.env.REACT_APP_SERVER_URL + '/api/inventory/deleteInvWatch/' + id,
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
            console.log('Deleted watch in inventory: ' + response.data);
            setWatches(watches.filter((watch) => watch._id !== id));
        } catch (e) {
            console.log(e.response.data.error);
        }
    }

    return (
        <div className="inventory-table-container">
            <div className="top-banner">
                <h2>Inventory</h2>
                <button className="btn btn-light" onClick={addWatch}><i className="fa-regular fa-plus"></i>Add Watch</button>
            </div>

            {/* Add watch to inventory Modal */}
            <Modal
                isOpen={openAddWatchModal}
                onRequestClose={closeAddWatchModal}
                contentLabel="Add watch to inventory"
            >
                <div className="modal-header">
                    <h2>Add Watch To Inventory</h2>
                    <button className="btn btn-light" onClick={closeAddWatchModal}>Close</button>
                </div>
                <AddNewInv />
            </Modal>

            {/* Edit watch Modal */}
            <Modal
                isOpen={openEditModal}
                onRequestClose={closeEdit}
                contentLabel="Edit Watch"
            >
                <div className="modal-header">
                    <h2>Edit Inventory</h2>
                    <button className="btn btn-light" onClick={closeEdit}>Close</button>
                </div>
                <EditInv watch={selectedWatch}/>
            </Modal>

            {/* Details Modal */}
            <Modal
                isOpen={openDetailsModal}
                onRequestClose={closeDetails}
                contentLabel="Watch Details"
            >
                <div className="modal-header">
                    <h2>Watch Details</h2>
                    <button className="btn btn-light" onClick={closeDetails}>Close</button>
                </div>
                <DetailsModal watch={selectedWatch}/>
            </Modal>

            {/* Create sale order */}
            <Modal
                isOpen={openCreateSOForm}
                onRequestClose={closeCreateSaleOrder}
                contentLabel="Create Sale Order"
            >
                <div className="modal-header">
                    <h2>Create Sale Order</h2>
                    <button className="btn btn-light" onClick={closeCreateSaleOrder}>Close</button>
                </div>
                <CreateSaleOrderForm watch={selectedWatch} />
            </Modal>

            <table className="inventory-table table">
                <thead>
                    <tr>
                        <th>Details</th>
                        {screenSize === 'large' && <th>Date Added</th>}
                        {screenSize !== 'small' && screenSize !== 'xsmall' && <th>Brand</th>}
                        <th>Model</th>
                        {screenSize !== 'xsmall' && <th>Year</th>}
                        {screenSize === 'large' && <th>Size</th>}
                        {screenSize === 'large' && <th>Condition</th>}
                        {screenSize !== 'small' && screenSize !== 'xsmall' && <th>Box</th>}
                        {screenSize !== 'small' && screenSize !== 'xsmall' && <th>Papers</th>}
                        {screenSize !== 'small' && screenSize !== 'xsmall' && <th>List Price</th>}
                        <th>Create S.O.</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {watches && watches.map((watch) => (                        
                        <tr key={watch._id}>
                            <td><button className='btn' onClick={() => details(watch)}><i className="fa-regular fa-eye"></i></button></td>
                            {screenSize === 'large' && <td>{watch.inventory.dateAdded.slice(0,10)}</td>}
                            {screenSize !== 'small' && screenSize !== 'xsmall'  && <td>{watch.brand}</td>}
                            <td>{watch.model}</td>
                            {screenSize !== 'xsmall' && <td>{watch.year}</td>}
                            {screenSize === 'large' && <td>{watch.size}</td>}
                            {screenSize === 'large' && <td>{watch.condition}</td>}
                            {/* circle-xmark or circle-check based on boolean value for box/papers */}
                            {screenSize !== 'small' && screenSize !== 'xsmall' && <td><i className={watch.box ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle-xmark'}></i></td>}
                            {screenSize !== 'small' && screenSize !== 'xsmall' && <td><i className={watch.papers ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle-xmark'}></i></td>}
                            {screenSize !== 'small' && screenSize !== 'xsmall' && <td>${watch.inventory.listPrice}</td>}
                            <td>{watch.status !== "Sold" ? <button className='btn' onClick={() => createSaleOrder(watch)}><i className="fa-solid fa-money-bill"></i></button> : ''}</td>
                            <td><button className='btn' onClick={() => edit(watch)}><i className="fa-solid fa-pen"></i></button></td>
                            <td><button className='btn' onClick={user ? () => deleteInv(watch._id) : null}><i className="fa-regular fa-trash-can"></i></button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default InventoryPage;